import { Action } from '@ngrx/store';

import { User } from '../../shared/models/user';
import { CodeForm, MinimalRegisterForm } from '../models/register.model';


export const REGISTER = '[Register] Register';
export const REGISTER_SUCCESS = '[Register] Register Success';
export const REGISTER_FAILURE = '[Register] Register Failure';

export const REGISTER_SEND_VALIDATION_LINK = '[Register] Register Send Validation Link';
export const REGISTER_SEND_VALIDATION_LINK_SUCCESS = '[Register] Register Send Validation Success';
export const REGISTER_SEND_VALIDATION_LINK_FAILURE = '[Register] Register Send Validation Failure';

export const REGISTER_CODE = '[Register] Register Code';
export const REGISTER_CODE_SUCCESS = '[Register] Register Code Success';
export const REGISTER_CODE_FAILURE = '[Register] Register Code Failure';

export const REGISTER_SELECT_METHOD = '[Register] Register Select Method';

export const REGISTER_RESET = '[Register] Register Reset';

export const CAPTCHA_CHECK_SUCCESS = '[Auth] Captcha Check Success';
export const CAPTCHA_EXPIRE = '[Auth] Captcha EXPIRE';
export const CAPTCHA_INIT_SUCCESS = '[Auth] Captcha Init Success';
export const CAPTCHA_INIT_FAILURE = '[Auth] Captcha Init Failure';

export const CAPTCHA_FAILURE = '[Auth] Captcha Failure';
export const CAPTCHA_SUCCESS = '[Auth] Captcha Success';


export class Register implements Action {
  readonly type = REGISTER;

  constructor(public payload: MinimalRegisterForm) {
  }
}

export class RegisterSuccess implements Action {
  readonly type = REGISTER_SUCCESS;

  constructor(public payload: { user: User }) {
  }
}

export class RegisterFailure implements Action {
  readonly type = REGISTER_FAILURE;

  constructor(public payload: any) {
  }
}

export class RegisterSelectMethod implements Action {
  readonly type = REGISTER_SELECT_METHOD;

  constructor(public payload: string) {
  }
}

export class RegisterSendValidationLink implements Action {
  readonly type = REGISTER_SEND_VALIDATION_LINK;
}

export class RegisterSendValidationLinkSuccess implements Action {
  readonly type = REGISTER_SEND_VALIDATION_LINK_SUCCESS;
}

export class RegisterSendValidationLinkFailure implements Action {
  readonly type = REGISTER_SEND_VALIDATION_LINK_FAILURE;

  constructor(public payload: any) {
  }
}

export class RegisterCode implements Action {
  readonly type = REGISTER_CODE;

  constructor(public payload: CodeForm) {
  }
}

export class RegisterCodeSuccess implements Action {
  readonly type = REGISTER_CODE_SUCCESS;

  constructor(public payload: { user: User }) {
  }
}

export class RegisterCodeFailure implements Action {
  readonly type = REGISTER_CODE_FAILURE;

  constructor(public payload: any) {
  }
}


export class CaptchaCheckSuccess implements Action {
  readonly type = CAPTCHA_CHECK_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CaptchaExpire implements Action {
  readonly type = CAPTCHA_EXPIRE;
}

export class CaptchaInitSuccess implements Action {
  readonly type = CAPTCHA_INIT_SUCCESS;

  constructor(public payload: string) {
  }
}

export class CaptchaInitFailure implements Action {
  readonly type = CAPTCHA_INIT_FAILURE;

  constructor(public payload: any) {
  }
}

export class CaptchaSuccess implements Action {
  readonly type = CAPTCHA_SUCCESS;

  constructor(public payload: any) {
  }
}

export class CaptchaFailure implements Action {
  readonly type = CAPTCHA_FAILURE;

  constructor(public payload: any) {
  }
}

export type Actions =
  | CaptchaCheckSuccess
  | CaptchaExpire
  | CaptchaInitSuccess
  | CaptchaInitFailure
  | CaptchaSuccess
  | CaptchaFailure
  | Register
  | RegisterSuccess
  | RegisterFailure
  | RegisterSelectMethod
  | RegisterSendValidationLink
  | RegisterSendValidationLinkSuccess
  | RegisterSendValidationLinkFailure
  | RegisterCode
  | RegisterCodeSuccess
  | RegisterCodeFailure;




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/actions/register.ts